import React, { useEffect, useState } from "react";
import { config } from "../../Config";
import { useStateContext } from "../../Providers/ContextProvider";
import { Render } from "@puckeditor/core";
import axiosClient from "../../axios-client";
import ZakaCalcComponent from "../ZakaCalcComponent";

function ZacCalc() {
  //   const [data, setData] = useState({ content: [], root: {} });
  //   const pageId = 2;

  //   const GetContent = async () => {
  //     axiosClient
  //       .get(`/pages/${pageId}`)
  //       .then((response) => {
  //         setData(response.data.data.content);
  //       })
  //       .catch((error) => {
  //         console.error("Error:", error);
  //       });
  //   };

  //   useEffect(() => {
  //     GetContent();
  //   }, []);

  //   return <Render config={config} data={data} />;
  return <ZakaCalcComponent />;
}

export default ZacCalc;
